import React from 'react';
import { Checkbox } from 'antd';
import { useTranslation } from 'react-i18next';

import { FormItem, useFormInstance, useWatchForm, PhoneInput } from '@/components';
import { Input } from '@/ui';

import { PartnerFormFieldsNames } from '../../helpers/types';
import { usePartnerFormRules } from '../../hooks';

interface IAccountantFields {
  isNew?: boolean;
}

const AccountantFields = ({ isNew = false }: IAccountantFields) => {
  const { t } = useTranslation('partners');
  const form = useFormInstance();
  const rules = usePartnerFormRules();

  const noAccountant = useWatchForm(['accountantDraft', 'noAccountant'], form);

  const firstName = useWatchForm(['accountantDraft', 'firstName'], form);
  const lastName = useWatchForm(['accountantDraft', 'lastName'], form);
  const middleName = useWatchForm(['accountantDraft', 'middleName'], form);
  const email = useWatchForm(['accountantDraft', 'email'], form);
  const phone = useWatchForm(['accountantDraft', 'phone'], form);

  const disabled = noAccountant === true;

  const hasAccountantData = [firstName, lastName, middleName, email, phone].some((value) => Boolean(value?.trim()));

  const required = !disabled && (isNew || noAccountant === false || hasAccountantData);

  return (
    <>
      <FormItem
        name={['accountantDraft', 'firstName']}
        label={t('partners_accountant_first_name')}
        required={required}
        rules={required ? rules[PartnerFormFieldsNames.FIRST_NAME] : []}
      >
        <Input disabled={disabled} />
      </FormItem>

      <FormItem
        name={['accountantDraft', 'lastName']}
        label={t('partners_accountant_last_name')}
        required={required}
        rules={required ? rules[PartnerFormFieldsNames.LAST_NAME] : []}
      >
        <Input disabled={disabled} />
      </FormItem>

      <FormItem
        name={['accountantDraft', 'middleName']}
        label={t('partners_accountant_middle_name')}
        required={required}
        rules={required ? rules[PartnerFormFieldsNames.MIDDLE_NAME] : []}
      >
        <Input disabled={disabled} />
      </FormItem>

      <FormItem
        name={['accountantDraft', 'email']}
        label={t('partners_accountant_email')}
        required={required}
        rules={required ? rules[PartnerFormFieldsNames.EMAIL] : []}
      >
        <Input disabled={disabled} />
      </FormItem>

      <FormItem
        name={['accountantDraft', 'phone']}
        label={t('partners_accountant_phone')}
        required={required}
        rules={required ? rules[PartnerFormFieldsNames.PHONE] : []}
      >
        <PhoneInput disabled={disabled} />
      </FormItem>

      <FormItem name={['accountantDraft', 'noAccountant']} valuePropName="checked">
        <Checkbox>{t('partners_no_accountant')}</Checkbox>
      </FormItem>
    </>
  );
};

export default AccountantFields;
